import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

const Reviews = ({ comentarios, lang }) => {
    const { t } = useTranslation();

    const formatDate = (dateString) => {
        const [year, month, day] = dateString.split('-');
        return `${day}/${month}/${year}`;
    };

    return (
        <div className="o-cont-fullw mb-100">
            <div className="container">
                {
                    comentarios.length > 0 ?
                        <>
                            <hotel-detail-swipper-reviews >
                                <h2 className="text-center h2">{t("Valoraciones")}</h2>
                                <figure className="c-review_tripadvisor">
                                    <img alt="" src="https://pro-static.h10hotels.com/templates/H10/src/logos/trip-advisor.svg" /></figure>
                                <div init="false" className="c-review" style={{ display: "flex", alignItems: "stretch", marginBottom: "3rem" }}>
                                    {comentarios.map((review, index) => (
                                        <div className="c-review__slide swiper-slide-active" style={{ marginRight: "16px" }} role="group" aria-label={`{${index + 1} / ${comentarios.length}`} data-swiper-slide-index={index} key={index}>
                                            <div className="c-review__comment">
                                                <div className="scroll">
                                                    <p className="text-md"><strong>Estancia en familka</strong></p>
                                                    <div className="c-review__user ms-auto">
                                                        <span><i className="fa-solid fa-user"></i></span>
                                                        <span>{review.nombre_persona}</span>
                                                    </div>
                                                    {ReactHtmlParser(review.texto[lang])}
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-baseline justify-content-between">
                                                <p className="points-value"><strong>5</strong>/5 </p>
                                                <tripadvisor-bubble>
                                                    <div className="d-flex align-items-center">
                                                        {
                                                            Array.from({ length: review.estrellas }).map((_, i) => (
                                                                <span key={i} className="o-rating full"></span>
                                                            ))
                                                        }

                                                    </div>
                                                </tripadvisor-bubble>
                                            </div>
                                            <div className="c-review__footer">
                                                <p>
                                                    <span>
                                                        <i className="fa-solid fa-calendar"></i>

                                                    </span> {formatDate(review.fecha)}
                                                </p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </hotel-detail-swipper-reviews>
                            <div className="d-flex justify-content-center">
                                <button type="button" className="btn btn-primary">{t("Ver todas las opiniones")}</button>
                            </div>
                        </>
                        :
                        ""
                }
            </div >
        </div >
    );
};

export default Reviews;
